/* THE SURVEY'S DATA, from what the console already has: the newest run, its analysis and (at a bed) the chart as the
   Resident has read it. No server route is added; a run whose analysis lists no harm or window has a log of cases only. */
import { runLogOf, type LogInput, type RunLog } from '../../world3d/log.ts'
import type { AnalysisBody } from '../types.ts'

export function logInputOf(body: AnalysisBody | null): LogInput {
  const s = body?.analysis.score
  return {
    cases: (s?.cases_table ?? []).map((c) => ({ case_ref: c.case_ref, bay: c.bay, died: c.died })),
    harms: (s?.harms ?? []).map((h) => ({ case_ref: h.case_ref, bay: h.bay, kind: h.kind, minute: h.minute, persistent_at_end: h.persistent_at_end })),
    windows: (s?.regret?.costliest ?? []).map((w) => ({ case_ref: w.case_ref, bay: w.bay, from_min: w.from_min, to_min: w.to_min, tools: w.tools })),
  }
}

export const surveyLog = (count: number, body: AnalysisBody | null): RunLog => runLogOf(count, logInputOf(body))

/** The bay of the last case the run played: where the Resident stands. */
export function residentBay(body: AnalysisBody | null, count: number): number | null {
  const t = body?.analysis.score.cases_table ?? []
  for (let i = t.length - 1; i >= 0; i--) if (t[i].bay >= 1 && t[i].bay <= count) return t[i].bay
  return null
}

import type { Problem } from './problems.ts'
import { resolvedSystems } from '../../world3d/scan.ts'
import type { BedSystem } from '../../world3d/build.ts'

/** The five shells of a bed from the problem list as the Resident has read it: each shell's state is its problem's pattern, and it resolves when a part that carries it has been read. */
export function bedSystems(problems: readonly Pick<Problem, 'key' | 'pattern'>[], read: readonly string[]): BedSystem[] {
  const resolved = resolvedSystems(read)
  return problems.map((p) => ({ key: p.key, pattern: p.pattern, resolved: resolved.includes(p.key) }))
}

/** The world's clock at case minute m: the run starts at midnight of Day 1. */
export function dayClock(m: number): string {
  const d = Math.floor(m / 1440)
  const r = m % 1440
  return `Day ${d + 1} ${String(Math.floor(r / 60)).padStart(2, '0')}:${String(r % 60).padStart(2, '0')}`
}
